module.exports = __webpack_public_path__ + "img/15_18.05c3f22e.png";